import ContactForm from './ContactForm.svelte';
export default new ContactForm({
  target: document.getElementById('contactform'),
});
